import { Outlet } from 'react-router-dom';
import Header from './Header';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import Menu from './Menu';
import "./Layout.scss";
import Toast from '../../components/Toast';

function Layout() {
    const { menuOpened } = useSelector((state: RootState) => state.general);

    if(menuOpened) {
        return <Menu/>
    }

    return (<div className='mafia-body'>
        <Header />
        <Toast/>
        <div className='mafia-content'>
            <Outlet />
        </div>
    </div>)
}

export default Layout;